<template>
  <!-- Frase da Black November nos modais de compra de licença e de convite, no visual
       do quadro preto dos cards de plano. -->
  <span class="campaign-offer-note">
    <span class="campaign-offer-note-tag">Black November:</span>
    {{ planName }} com {{ discount }}% off <strong>nos 2 primeiros meses</strong>
  </span>
</template>

<script>
export default {
  name: 'CampaignOfferNote',
  props: {
    planName: {
      type: String,
      required: true
    },
    // Saída de `campaignDiscount` (plan-showcase.js)
    discount: {
      type: Number,
      required: true
    }
  }
}
</script>

<style lang="scss" scoped>
.campaign-offer-note {
  display: inline-block;
  padding: 2px 8px;
  border-radius: 4px;
  background: #0b0b0f;
  color: #fff;
  font-size: 12px;
  line-height: 16px;
  font-weight: 400;
  white-space: normal;

  strong { font-weight: 700; }
}
// Amarelo do título do quadro preto dos cards ("BLACK NOVEMBER · ATÉ 29/11").
.campaign-offer-note-tag {
  color: #ffd23f;
  font-weight: 700;
}
</style>



// WEBPACK FOOTER //
// src/components/Subscription/CampaignOfferNote.vue